import React from "react";
import { Row } from "antd";
import FileItemRender from "./children/FileItemRender";

const FileListModalRender = ({ files, handleSelectClick, handleDelete, handleDownloadClick, selectGuidList, isEditing }) => {
  return (
    <div>
      <div className="Files">
        <Row gutter={[16, 24]} justify="flex-start" align="middle">
          {files.length > 0
            ? files.map((item, index) => (
              <FileItemRender
                handleSelectClick={handleSelectClick}
                handleDelete={handleDelete}
                handleDownloadClick={handleDownloadClick}
                selectGuidList={selectGuidList}
                index={index}
                key={index}
                file={item}
                isEditing={isEditing}
              />
            ))
            : null}
        </Row>
      </div>
    </div>
  );
};

export default FileListModalRender;
